import { render, staticRenderFns } from "./FundTaxation.vue?vue&type=template&id=6b563d42&scoped=true"
import script from "./FundTaxation.vue?vue&type=script&lang=js"
export * from "./FundTaxation.vue?vue&type=script&lang=js"
import style0 from "./FundTaxation.vue?vue&type=style&index=0&id=6b563d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b563d42",
  null
  
)

export default component.exports